import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconCross({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.secondary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.39 4.18565C4.67435 4.27003 4.1212 4.85755 4.0712 5.58883C4.04932 5.8826 4.09932 6.12323 4.23371 6.39512C4.33058 6.58575 4.5806 6.84514 7.07758 9.33899L9.81207 12.0735L7.04945 14.8392C4.15558 17.7394 4.16183 17.7331 4.04932 18.1175C3.98057 18.355 3.98369 18.7831 4.0587 19.0238C4.20558 19.4957 4.54934 19.8269 5.02124 19.9488C5.24625 20.0082 5.7744 20.0082 5.9869 19.9519C6.38692 19.8457 6.3463 19.8832 9.24954 16.9799L11.984 14.2455L14.7342 16.9924C17.6374 19.8926 17.5686 19.8301 17.9718 19.9457C18.2124 20.0176 18.7218 20.0176 18.9593 19.9488C19.5937 19.7676 20 19.2144 20 18.53C20 18.1925 19.9219 17.9175 19.7625 17.6768C19.7 17.5862 18.4187 16.2862 16.9124 14.7861L14.1716 12.0641L16.9092 9.31712C19.5 6.72013 19.65 6.56388 19.7344 6.37012C19.9937 5.77634 19.8687 5.08569 19.425 4.65129C19.0812 4.31378 18.7749 4.19815 18.2718 4.22003C17.8905 4.23878 17.6812 4.31066 17.4155 4.51066C17.3155 4.58567 16.053 5.82947 14.6123 7.27328L11.9872 9.89839L9.25892 7.18265C7.32134 5.25445 6.4838 4.44191 6.36505 4.37628C6.07753 4.21065 5.73689 4.14502 5.39 4.18565Z" />
    </svg>
  );
}
